import { useContext, useEffect } from 'react';
import { SignalRContext } from 'contexts/signalR';
import { SignalREvents } from 'constants/signalR';

export const useSignalREvent = (event: SignalREvents, callback: (arg: string) => void): void => {
  const { connection, setMethods, methods } = useContext(SignalRContext);

  useEffect(() => {
    if (!methods.includes(event)) {
      connection?.on(event, callback);
      setMethods(event);
    }
  }, []);
};
